<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP" id="pt1"> </p>
<p class="PN"><span epub:type="pagebreak" id="pg_1" title="1"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="ePub-SC">PART ONE</span></span></span></p>
<p class="PTT"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample">THE ASPIRING CHANTEUSE</span></p>
<p class="PEP">An opera begins long before the curtain goes up and ends long after it has come down. It starts in my imagination, it becomes my life, and it stays part of my life long after I’ve left the opera house.</p>
<p class="PEPC"><span class="ePub-I">—Maria Callas</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?d43f70b0